export const getSessionUserIds = (session) => ({
  userId: session?.id ?? session?._id,
  userRoleId: session?.userRole?._id ?? session?.userRole,
});

export const isSameId = (a, b) =>
  a != null && b != null && String(a) === String(b);

export const getCurrentStepDef = (process, request) => {
  const sorted = (process?.steps ?? []).slice().sort((a, b) => a.order - b.order);
  return sorted[request?.currentStep ?? 0] ?? null;
};

export const isUserApproverForStep = (userId, userRoleId, step) => {
  if (!step || !userId) return false;
  const approverMatch = (step.approvers ?? []).some((id) =>
    isSameId(id?._id ?? id, userId)
  );
  const roleMatch =
    userRoleId &&
    (step.approverRoles ?? []).some((id) => isSameId(id?._id ?? id, userRoleId));
  return approverMatch || roleMatch;
};

export const stepHasApprovers = (step) =>
  !!step &&
  ((step.approvers?.length ?? 0) > 0 || (step.approverRoles?.length ?? 0) > 0);

export const getMcaRequestPermissions = (request, session) => {
  const { userId, userRoleId } = getSessionUserIds(session);
  const process = request?.process;
  const isMaker = isSameId(request?.maker?._id ?? request?.maker, userId);
  const canAct = ["PENDING", "IN_PROGRESS"].includes(request?.status);
  const stepDef = getCurrentStepDef(process, request);
  const isApprover = isUserApproverForStep(userId, userRoleId, stepDef);
  const canApprove = canAct && !isMaker && isApprover;
  const noApproversConfigured = canAct && stepDef && !stepHasApprovers(stepDef);

  return {
    userId,
    isMaker,
    canAct,
    isApprover,
    canApprove,
    noApproversConfigured,
    stepDef,
  };
};
